export const systemColours = [
  'primary',
  'secondary',
  'president',
  'president-light',
  'president-lighter',
  'grey',
  'grey-light',
  'grey-lighter',
  'gold',
  'vermilion',
  'vermilion-dark',
  'purple',
  'grape',
  'red',
  'red-light',
  'red-dark',
  'red-darker',
  'orange',
  'orange-light',
  'orange-dark',
  'orange-darker',
  'green',
  'green-light',
  'green-dark',
  'blue',
  'petrol',
  'yellow',
  'white',
  'rivergreen',
  'mobired',
] as const

export type SystemColour = (typeof systemColours)[number]

//Shades ranging from 50 to 950
type SystemShades = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950

export type ShadedSystemColour = `${SystemColour}-${SystemShades}`
export type ShadedSystemBgColour = `bg-${ShadedSystemColour}`
export type TextColour = `text-${SystemColour}`

export type SystemColourMapping = Record<SystemColour, string>
export const systemColourMapping: SystemColourMapping = {
  grey: 'cft-component-grey',
  'grey-light': 'cft-component-grey-light',
  'grey-lighter': 'cft-component-grey-lighter',
  president: 'cft-component-president',
  'president-light': 'cft-component-president-light',
  'president-lighter': 'cft-component-president-lighter',
  blue: 'cft-component-blue',
  gold: 'cft-component-gold',
  grape: 'cft-component-grape',
  green: 'cft-component-green',
  'green-light': 'cft-component-green-light',
  'green-dark': 'cft-component-green-dark',
  orange: 'cft-component-orange',
  'orange-light': 'cft-component-orange-light',
  'orange-dark': 'cft-component-orange-dark',
  'orange-darker': 'cft-component-orange-darker',
  petrol: 'cft-component-petrol',
  primary: 'cft-component-primary',
  purple: 'cft-component-purple',
  red: 'cft-component-red',
  'red-light': 'cft-component-red-light',
  'red-dark': 'cft-component-red-dark',
  'red-darker': 'cft-component-red-darker',
  secondary: 'cft-component-secondary',
  vermilion: 'cft-component-vermilion',
  'vermilion-dark': 'cft-component-vermilion-dark',
  white: 'cft-component-white',
  yellow: 'cft-component-yellow',
  rivergreen: 'cft-component-rivergreen',
  mobired: 'cft-component-mobired',
}

export const systemColourTextMapping: SystemColourMapping = {
  grey: 'cft-text-grey',
  'grey-light': 'cft-text-grey-light',
  'grey-lighter': 'cft-text-grey-lighter',
  president: 'cft-text-president',
  'president-light': 'cft-text-president-light',
  'president-lighter': 'cft-text-president-lighter',
  blue: 'cft-text-blue',
  gold: 'cft-text-gold',
  grape: 'cft-text-grape',
  green: 'cft-text-green',
  'green-light': 'cft-text-green-light',
  'green-dark': 'cft-text-green-dark',
  orange: 'cft-text-orange',
  'orange-light': 'cft-text-orange-light',
  'orange-dark': 'cft-text-orange-dark',
  'orange-darker': 'cft-text-orange-darker',
  petrol: 'cft-text-petrol',
  primary: 'cft-text-primary',
  purple: 'cft-text-purple',
  red: 'cft-text-red',
  'red-light': 'cft-text-red-light',
  'red-dark': 'cft-text-red-dark',
  'red-darker': 'cft-text-red-darker',
  secondary: 'cft-text-secondary',
  vermilion: 'cft-text-vermilion',
  'vermilion-dark': 'cft-text-vermilion-dark',
  white: 'cft-text-white',
  yellow: 'cft-text-yellow',
  rivergreen: 'cft-text-rivergreen',
  mobired: 'cft-text-mobired',
}
